import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-ticket-status-badge',
  standalone: true,
  imports: [CommonModule],
  styleUrls: ['./ticket-status-badge.component.scss'],
  template: `
    <span
      *ngIf="type === 'priority'"
      class="badge rounded-pill text-uppercase"
      [ngClass]="{
        'bg-light-danger text-danger border border-danger-subtle':
          color === 'critical',
        'bg-light-warning text-warning border border-warning-subtle':
          color === 'high',
        'bg-light-info text-info border border-info-subtle': color === 'medium',
        'bg-light-success text-success border border-success-subtle':
          color === 'low'
      }"
    >
      <i
        class="feather position-relative icon-align"
        [ngClass]="{
          'icon-alert-triangle': color === 'critical',
          'icon-alert-circle': color === 'high',
          'icon-info': color === 'medium',
          'icon-check-circle': color === 'low'
        }"
      ></i>
      <span class="ms-1">{{ label }}</span>
    </span>

    <span
      *ngIf="type === 'status'"
      class="badge rounded-pill fw-bold text-uppercase"
      [ngClass]="{
        'bg-light-primary text-primary':
          color === 'open' || color === 'primary',
        'bg-light-warning text-warning':
          color === 'in-progress' || color === 'warning',
        'bg-light-success text-success': color === 'success',
        'badge-ticket-status-closed': color === 'closed',
        'bg-light-secondary text-secondary border border-secondary':
          color === 'secondary',
        'bg-light text-secondary border border-secondary':
          color === 'cancelled'
      }"
    >
      {{ label }}
    </span>
  `,
})
export class TicketStatusBadgeComponent {
  @Input() type: 'priority' | 'status' = 'status';
  @Input() color: string = '';
  @Input() label: string = '';
}
